import { AutocompleteGrouped } from '@wajeez-web/components/mui';
import { FieldValues, UseControllerProps } from 'react-hook-form';
import { DefaultInputTypeV2 } from '@wajeez-web/components/ui';

import { FormInputController } from '../FormInputController';
import { SelectFormTypeV2 } from '../Types';

export interface FormAutocompleteGroupedV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    DefaultInputTypeV2 {
  fieldMeta: SelectFormTypeV2;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormAutocompleteGroupedV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormAutocompleteGroupedV2Props<TFormFields>) => {
  const { label, ...otherProps } = props;

  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ value, ...controllerProps }) => (
        <AutocompleteGrouped
          options={fieldMeta.fieldOptions?.selectOptions || []}
          label={fieldMeta.label}
          color="#1f7983"
          value={JSON.stringify(value)}
          {...controllerProps}
          {...otherProps}
        />
      )}
      {...props}
    />
  );
};
